
import { defineComponent } from 'vue';

import MobileSupportButton from './MobileSupportButton.vue';

export default defineComponent({
  name: 'SupportButtons',
  components: {
    MobileSupportButton,
  },
  data() {
    return {
      scrolled: false,
      clicked: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 0) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    });
  },
  methods: {
    clickHandler() {
      this.clicked = !this.clicked;
      if (this.clicked === true) {
        setTimeout(() => {
          this.clicked = false;
        }, 3000);
      }
    },
  },
});
